import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div ...attributes {{did-insert this.removeLoad}}></div>",{ moduleName: "cio/components/cio-load-remover/index.hbs" })